// extracted by mini-css-extract-plugin
export default {"mid_gy":"index_mid_gy_3AQzM","mid_gy_left":"index_mid_gy_left_Y0low","current":"index_current_-P--N","mid_gy_right":"index_mid_gy_right_H4-EU"};